import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {ZoomControlsComponent} from "../../components/zoom-controls/zoom-controls.component";
import {debounceTime} from "rxjs/operators";
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";

@Component({
  selector: 'app-zoom-controls',
  templateUrl: './zoom-controls.component.html',
  styleUrls: ['./zoom-controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZoomControlsComponent21 extends ZoomControlsComponent {
  public zoom = 0;

  @Input() slidesState = 'closed';

  constructor(
    protected adapter: CesiumAdapterService,
    private view: CesiumAdapterService,
    protected cd: ChangeDetectorRef
  ) {
    super(adapter, cd);
  }

  ngOnInit() {
    super.ngOnInit();
    this.view.zoom.pipe(debounceTime(200)).subscribe((level) => {
      this.zoom = level;
      this.cd.detectChanges();
    });
    this.cd.detectChanges();
  }

}
